import { Stack, Title } from "@mantine/core";
import { ContextModalProps } from "node_modules/@mantine/modals/lib/context";
import z from "zod";

import { EditSchedulingArgsAsProps, SchedulingForm, extendedEditSchedulingArgsSchema } from "@/features/dashboard/pedidos/_components/SchedulingForm";

type ExtendedEditSchedulingArgsSchema = z.infer<typeof extendedEditSchedulingArgsSchema>;

export type CreateEditSchedulingModalProps = {
  schedule?: EditSchedulingArgsAsProps;
  onSubmit: (data: ExtendedEditSchedulingArgsSchema) => void;
  onDeny?: () => void;
  onConfirm?: () => void;
  defaultValues?: Partial<Pick<ExtendedEditSchedulingArgsSchema, "qtyOrdered" | "expirationDate">>;
};

export function CreateEditSchedulingModal({ innerProps }: ContextModalProps<CreateEditSchedulingModalProps>) {
  const { schedule, onSubmit, onDeny, onConfirm, defaultValues } = innerProps;

  return (
    <Stack>
      <Title order={3}>{schedule?.id || schedule?.id === 0 ? "Editar Carregamento" : "Novo Carregamento"}</Title>

      <SchedulingForm schedule={innerProps?.schedule} defaultValues={defaultValues} onSubmit={onSubmit} onDeny={onDeny} onConfirm={onConfirm} />
    </Stack>
  );
}
